import { render, staticRenderFns } from "./modalEliminarResultados.vue?vue&type=template&id=2d1674f8&scoped=true"
import script from "./modalEliminarResultados.vue?vue&type=script&lang=js"
export * from "./modalEliminarResultados.vue?vue&type=script&lang=js"
import style0 from "./modalEliminarResultados.vue?vue&type=style&index=0&id=2d1674f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1674f8",
  null
  
)

export default component.exports